import { render, staticRenderFns } from "./attachementupload.vue?vue&type=template&id=72ff7185&scoped=true"
import script from "./attachementupload.vue?vue&type=script&lang=js"
export * from "./attachementupload.vue?vue&type=script&lang=js"
import style0 from "./attachementupload.vue?vue&type=style&index=0&id=72ff7185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff7185",
  null
  
)

export default component.exports